/* EvelRide universal supplier variant choices. Non-size options use image tiles; sizes use a dropdown. */
(() => {
  if (window.EvelRideVariantChoices) return;
  const sizeRegex=/(?:^|[\s\-\/|])((?:(?:US|EU)\s*)?(?:[2-5]?XL|XXXL|XXL|XXS|XS|S|M|L|SM|MD|LG|Small|Medium|Large|X-Small|X-Large|2X-Large|3X-Large|4X-Large|5X-Large|OS|OSFA|OSFM|One Size|One-Size|Universal|Youth (?:XS|SM|MD|LG|S|M|L|XL|2XL|Small|Medium|Large)|Y(?:XS|S|M|L|XL)|(?:US|EU)\s*\d{1,2}(?:\.\d)?|\d{1,2}(?:\.\d)?(?:\s*\/\s*(?:US|EU)?\s*\d{1,2}(?:\.\d)?)?|\d{2}\s*[xX]\s*\d{2}))$/i;
  const sizeNorm=t=>({small:'S',medium:'M',large:'L',sm:'S',md:'M',lg:'L','xxl':'2XL','xxxl':'3XL'}[String(t||'').toLowerCase()]||String(t||''));
  const removeStart=(description,model)=> {
    const s=String(description||'').trim(),m=String(model||'').trim();
    const index=m?s.toLowerCase().indexOf(m.toLowerCase()):-1;
    return index>=0 ? s.slice(index+m.length).replace(/^[\s\-:|·]+/,'').trim() : s;
  };
  const parse=(v,model)=>{
    const label=removeStart(v.description||v.label||v.title||'',model);
    let size=String(v.size||'').trim(),visual=String(v.visualKey||v.color||v.finish||v.graphic||v.style||'').trim();
    let remaining=label;
    if(!size){const inferred=legacy({value:label,modelName:model,productType:v.productType||''});if(inferred){size=inferred.size;remaining=inferred.visual;}}
    if(!size){
      const m=label.match(sizeRegex);
      if(m){size=sizeNorm(m[1].trim());remaining=label.slice(0,m.index).replace(/[\s\-\/|·]+$/,'').trim();}
    }
    if(!visual)visual=remaining||'';
    else {
      visual=removeStart(visual,model);
      const inferred=legacy({value:visual,modelName:model,productType:v.productType||''});if(inferred)visual=inferred.visual;
      const suffix=visual.match(sizeRegex);
      if(suffix)visual=visual.slice(0,suffix.index).replace(/[\s\-\/|·]+$/,'').trim();
    }
    visual=visual.replace(/^[\s\-:|·]+|[\s\-:|·]+$/g,'').trim();
    if(visual==='Default Title')visual='';
    return {value:String(v.value??v.id??v.sku??''),visual,size,image:String(v.image||''),sku:v.sku||'',available:v.available!==false,source:v};
  };
  function enhance({select,variants,modelName='',anchor,preview,restore,root,visualLabel='Color / Style',sizeLabel='Size',imageUrl}={}){
    if(!select||!variants?.length||select.dataset.erChoices)return false;
    const parsed=variants.map(v=>parse({...v,image:window.EvelRideMedia?.repairImage(v.sku)||v.image||window.EvelRideMedia?.image(v.sku)},modelName));
    if(parsed.some(x=>!x.value)||new Set(parsed.map(x=>x.value)).size!==parsed.length)return false;
    const hasSizes=parsed.some(x=>x.size);
    const groups=[...new Set(parsed.map(v=>v.visual))];
    const hasVisual=groups.length>1;
    if(!hasVisual&&!hasSizes)return false;
    if(hasSizes&&parsed.some(v=>!v.size))return false;
    if(new Set(parsed.map(v=>JSON.stringify([v.visual,v.size]))).size!==parsed.length)return false;
    const label=anchor||select.closest('label');
    if(!label||!label.parentNode)return false;
    select.dataset.erChoices='true';label.hidden=true;
    const container=document.createElement('div');container.className='er-choice-layout';container.dataset.erChoices='true';
    const groupWrap=document.createElement('div');groupWrap.className='er-choice-group';
    const groupLabel=document.createElement('p');groupLabel.className='er-choice-caption';groupLabel.textContent=visualLabel;
    const tiles=document.createElement('div');tiles.className='er-choice-thumbs';tiles.setAttribute('role','group');tiles.setAttribute('aria-label',visualLabel);
    if(hasVisual){groupWrap.append(groupLabel,tiles);container.append(groupWrap);}
    const sizeWrap=document.createElement('label');sizeWrap.className='er-choice-size';sizeWrap.textContent=sizeLabel;
    const sizeInput=document.createElement('select');sizeInput.setAttribute('aria-label',sizeLabel);sizeWrap.append(sizeInput);
    if(hasSizes)container.append(sizeWrap);
    label.before(container);
    const current=()=>parsed.find(v=>v.value===select.value)||parsed[0];
    const src=v=>v?.image?(imageUrl?imageUrl(v.image):v.image):'';
    const valuesFor=visual=>parsed.filter(v=>v.visual===visual);
    const sizeOrder=['3XS','2XS','XS','S','M','L','XL','2XL','3XL','4XL','5XL'];
    const sortSizes=values=>values.sort((a,b)=>{const x=sizeOrder.indexOf(a),y=sizeOrder.indexOf(b);return x>=0&&y>=0?x-y:x>=0?-1:y>=0?1:a.localeCompare(b,undefined,{numeric:true});});
    const pick=(visual,size)=>{
      const matches=valuesFor(visual);
      return matches.find(v=>v.size===size)||matches.find(v=>v.available)||matches[0];
    };
    const set=v=>{
      if(!v)return;
      if(select.value!==v.value){select.value=v.value;select.dispatchEvent(new Event('change',{bubbles:true}));}
      sync();restoreSelected();
    };
    const restoreSelected=()=>{const active=current(),photo=src(active);if(photo&&preview)preview(photo,active.visual);else restore?.();};
    const draw=()=>{
      if(!hasVisual)return;
      tiles.replaceChildren();
      const active=current();
      const images=new Map(groups.map(g=>[g,[...new Set(valuesFor(g).map(src).filter(Boolean))]]));
      for(const value of groups){
        const example=pick(value,active.size),pictures=images.get(value);
        const picture=pictures?.[0],usedElsewhere=picture&&groups.some(g=>g!==value&&images.get(g)?.includes(picture));
        const button=document.createElement('button');button.type='button';button.className='er-choice-thumb';button.dataset.choiceValue=value;
        button.setAttribute('aria-pressed',String(value===active.visual));button.setAttribute('aria-label',value||'Default');
        button.title=value||'Default';
        if(picture&&!usedElsewhere){const img=document.createElement('img');img.src=picture;img.alt='';img.loading='lazy';button.append(img);}
        const label=document.createElement('span');label.textContent=value||'Default';button.append(label);
        if(picture&&!usedElsewhere&&preview){
          button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')preview(picture,value);});
          button.addEventListener('focus',()=>preview(picture,value));
          button.addEventListener('pointerleave',restoreSelected);
          button.addEventListener('blur',restoreSelected);
        }
        button.addEventListener('click',()=>set(example));tiles.append(button);
      }
    };
    const sync=()=>{
      const active=current();
      if(hasSizes){
        const sizes=sortSizes([...new Set(valuesFor(active.visual).map(v=>v.size))]);
        if(JSON.stringify([...sizeInput.options].map(o=>o.value))!==JSON.stringify(sizes))sizeInput.replaceChildren(...sizes.map(s=>new Option(s,s)));
        sizeInput.value=active.size;
      }
      if(hasVisual)for(const b of tiles.children)b.setAttribute('aria-pressed',String(b.dataset.choiceValue===active.visual));
    };
    if(hasSizes)sizeInput.addEventListener('change',()=>set(pick(current().visual,sizeInput.value)));
    select.addEventListener('change',sync);
    draw();sync();
    window.EvelRideMedia?.ready?.then(()=>{
      let changed=false;
      for(const v of parsed){
        const photo=window.EvelRideMedia?.repairImage(v.sku)||window.EvelRideMedia?.image(v.sku);
        if(photo&&photo!==v.image){v.image=photo;v.source.image=photo;changed=true;}
      }
      if(changed){draw();sync();restoreSelected();}
    }).catch(()=>{});
    return true;
  }
  /* Interpret legacy distributor Specification strings without changing Shopify SKU/ID. */
  function legacy({value,modelName='',productType=''}={}){
    const model=String(modelName||''),type=String(productType||'');
    if(!/(?:shirt|tee|hoodie|sweat|jacket|jersey|pants|shorts|jeans|gloves|sock|footwear|boots?|shoes?|helmet|onesie|toddler|youth|vest|suit|underwear|apparel|headwear|balaclava|base.layer|riding.gear|protect|armor|armour)/i.test(model+' '+type))return null;
    const original=removeStart(String(value||'').split(/\s+\|\s+/)[0].trim(),model);
    const marked=original.match(/\bSIZE\s*[:=\-]?\s*((?:(?:US|EU)\s*)?(?:\d{1,2}\s*[xX/]\s*\d{1,2}|\d{1,2}(?:\.\d)?|(?:XS|SM|MD|LG|XL|S|M|L)\/(?:SM|MD|LG|XL|S|M|L)|X{1,4}[- ]?(?:SMALL|LARGE)|[2-6]XL|[2-6]X|XXXL|XXL|XXS|XS|SM|MD|MED|LG|XL|S|M|L|SMALL|MEDIUM|LARGE|ONE SIZE|OSFA|OSFM))(?=\s|$)/i);
    if(marked){const rawSize=marked[1].trim(),upper=rawSize.toUpperCase(),map={SM:'S',MD:'M',MED:'M',LG:'L',SMALL:'S',MEDIUM:'M',LARGE:'L','2X':'2XL','3X':'3XL','4X':'4XL','5X':'5XL',XXL:'2XL',XXXL:'3XL'};return {size:map[upper]||rawSize,visual:(original.slice(0,marked.index)+' '+original.slice(marked.index+marked[0].length)).replace(/\s+/g,' ').trim(),rawSize,source:original};}
    const m=original.match(/(?:^|[\s\-\/|])((?:Y(?:XS|S|M|L|X|2X)|YOUTH\s+(?:XS|SM|MD|LG|S|M|L|XL)|[2-5]XS|[2-5]XL|[2-5]X|XXXL|XXL|XXS|XS|SM|MD|MED|LG|S|M|L|XL|SMALL|MEDIUM|LARGE|X-SMALL|X-LARGE|ONE SIZE|OSFA|OSFM|NEWBORN|[1-6]T|(?:6|12|18|24)\s+MONTHS?|(?:S|M|L)\/(?:M|L|XL)|\d{2}\s*[xX]\s*\d{2}|\d{1,2}(?:\.\d)?))$/i);
    if(!m)return null;
    const rawSize=m[1].trim(),upper=rawSize.toUpperCase();
    const digits=upper.match(/^\d{1,2}(?:\.\d)?$/);
    if(digits&&!/(?:boot|shoe|footwear|pants|jean|size|helmet|glove|sock)/i.test(model+' '+type))return null;
    const sizeMap={SM:'S',MD:'M',MED:'M',LG:'L','2X':'2XL','3X':'3XL','4X':'4XL','5X':'5XL','YM':'Youth M','YL':'Youth L','YX':'Youth XL','YS':'Youth S','YXS':'Youth XS','Y2X':'Youth 2XL','XXL':'2XL','XXXL':'3XL'};
    const size=sizeMap[upper]||({SMALL:'S',MEDIUM:'M',LARGE:'L'}[upper])||rawSize;
    let rest=original.slice(0,m.index).replace(/[\s\-\/|·]+$/,'').trim();
    const title=model.replace(/\s*\(\d{4}\)\s*/g,' ').trim();
    const norm=s=>s.replace(/[’']/g,'').replace(/[^a-z0-9]+/gi,' ').trim().toUpperCase().split(/\s+/).filter(Boolean);
    const rawWords=norm(rest);
    const titleWords=norm(title);
    for(const candidate of [titleWords,titleWords.slice(1)]){
      if(!candidate.length||rawWords.length<candidate.length)continue;
      if(candidate.every((w,i)=>rawWords[i]===w)){rest=rawWords.slice(candidate.length).join(' ');break;}
    }
    const visual=rest.replace(/^[\s\-:|·]+|[\s\-:|·]+$/g,'').trim();
    return {size,visual,rawSize,source:original};
  }
  window.EvelRideVariantChoices={enhance,parse,legacy};
})();

